import React from 'react'
import HeaderSearchbar from './SearchBar'
import { useSession } from 'hooks/useSession';
import { useNavigate } from 'react-router';
import { showMainToast } from 'utils/showToast';
import { fetchWrapper } from 'utils/apiFetch';

function Header() {
    const {name, userid, role} = useSession();
    const navigate = useNavigate()
    const handleLogout = async () => {

    try {

        const token = localStorage.getItem("token");

        await fetchWrapper("/https://api.mokshiq.in/logout_api", {
           
            
        });

    } catch (error) {

        console.log("Logout API Error:", error);

    }

    // Clear storage
    localStorage.clear();
    sessionStorage.clear();

    showMainToast("Log out successfully", "success");

    // Force full app reload
    window.location.replace("/");
};
  return (
    <header class="header-main">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-6 col-sm-4 d-flex align-items-center header-left p-0">
                           <span class="header-toggle me-3">
                             <i class="iconoir-view-grid"></i>
                           </span>
                        </div>

                        <div class="col-6 col-sm-8 d-flex align-items-center justify-content-end header-right p-0">

                            <ul class="d-flex align-items-center">

                                <li class="header-cloud">
                                    <a aria-controls="cloudoffcanvasTops" class="head-icon"
                                       data-bs-target="#cloudoffcanvasTops" data-bs-toggle="offcanvas"
                                       href="#" role="button">
                                        <i class="iconoir-dew-point text-primary f-s-26 me-1"></i>
                                        <span class="f-w-600">26 <sup class="f-s-10">°C</sup></span>
                                    </a>

                                    <div aria-labelledby="cloudoffcanvasTops"
                                         class="offcanvas offcanvas-end header-cloud-canvas"
                                         id="cloudoffcanvasTops"
                                         tabindex="-1">
                                        <div class="offcanvas-body p-0">
                                            <div class="cloud-body">

                                                <div class="cloud-content-box">
                                                    <div class="cloud-box bg-primary-900">
                                                        <p class="mb-3">Mon</p>
                                                        <h6 class="mt-4 f-s-13"> +29°C</h6>
                                                        <span>
                                <i class="ph-duotone  ph-cloud-fog text-white f-s-25"></i>
                              </span>
                                                        <p class="f-s-13 mt-3"><i class="wi wi-raindrop"></i> 2%</p>
                                                    </div>
                                                    <div class="cloud-box bg-primary-800">
                                                        <p class="mb-3">Tue</p>
                                                        <h6 class="mt-4 f-s-13"> +29°C</h6>
                                                        <span>
                                <i class="ph-duotone  ph-cloud-sun text-white f-s-25"></i>
                              </span>
                                                        <p class="f-s-13 mt-3"><i class="wi wi-raindrop"></i> 2%</p>
                                                    </div>
                                                    <div class="cloud-box bg-primary-700">
                                                        <p class="mb-3 text-light">Wed</p>
                                                        <h6 class="mt-4 f-s-13"> +20°C</h6>
                                                        <span>
                                <i class="ph-duotone  ph-sun-dim text-white f-s-25"></i>
                              </span>
                                                        <p class="f-s-13 mt-3"><i class="wi wi-raindrop"></i> 1%</p>
                                                    </div>
                                                    <div class="cloud-box bg-primary-600">
                                                        <p class="mb-3">Thu</p>
                                                        <h6 class="mt-4 f-s-13"> +17°C</h6>
                                                        <span>
                                <i class="ph-duotone  ph-sun-dim text-white f-s-25"></i>
                              </span>
                                                        <p class="f-s-13 mt-3"><i class="wi wi-raindrop"></i> 1%</p>
                                                    </div>
                                                    <div class="cloud-box bg-primary-500">
                                                        <p class="mb-3">Fri</p>
                                                        <h6 class="mt-4 f-s-13"> +18°C</h6>
                                                        <span>
                                <i class="ph-duotone  ph-sun-dim text-white f-s-25"></i>
                              </span>
                                                        <p class="f-s-13 mt-3"><i class="wi wi-raindrop"></i> 1%</p>
                                                    </div>
                                                    <div class="cloud-box bg-primary-400">
                                                        <p class="mb-3">Sat</p>
                                                        <h6 class="mt-4 f-s-13"> +16°C</h6>
                                                        <span>
                                <i class="ph-duotone  ph-sun-dim text-white f-s-25"></i>
                              </span>
                                                        <p class="f-s-13 mt-3"><i class="wi wi-raindrop"></i> 1%</p>
                                                    </div>
                                                    <div class="cloud-box bg-primary-300">
                                                        <p class="mb-3">Sun</p>
                                                        <h6 class="mt-4 f-s-13"> +29°C</h6>
                                                        <span class="mb-3">
                                <i class="ph-duotone  ph-sun-dim text-white f-s-25"></i>
                              </span>
                                                        <p class="f-s-13 mt-3"><i class="wi wi-raindrop"></i> 1%</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>

                                <li class="header-language">
                                    <div class="flex-shrink-0 dropdown" id="lang_selector">
                                        <a aria-expanded="false" class="d-block head-icon ps-0"
                                           data-bs-toggle="dropdown"
                                           href="#">
                                            <div class="lang-flag lang-en ">
                          <span class="flag rounded-circle overflow-hidden">
                            <i class=""></i>
                          </span>
                                            </div>
                                        </a>
                                        <ul class="dropdown-menu language-dropdown header-card border-0">
                                            <li class="lang lang-en selected dropdown-item p-2" data-bs-placement="top"
                                                data-bs-toggle="tooltip" title="US">
                          <span class="d-flex align-items-center">
                            <i class="flag-icon flag-icon-usa flag-icon-squared b-r-10 f-s-22"></i>
                            <span class="ps-2">English</span>
                          </span>
                                            </li>
                                            
                                        </ul>
                                    </div>

                                </li>

                                {/* <HeaderSearchbar/> */}

                                <li class="header-apps">
                                    <a aria-controls="appscanvasRights" class="d-block head-icon"
                                       data-bs-target="#appscanvasRights" data-bs-toggle="offcanvas"
                                       href="#" role="button">
                                        <i class="iconoir-key-command"></i>
                                    </a>

                                    <div aria-labelledby="appscanvasRightsLabel"
                                         class="offcanvas offcanvas-end header-apps-canvas"
                                         id="appscanvasRights"
                                         tabindex="-1">
                                        <div class="offcanvas-header">
                                            <h5 class="offcanvas-title" id="appscanvasRightsLabel">Shortcut</h5>
                                            <div class="app-dropdown flex-shrink-0">
                                                <a aria-expanded="false" class=" p-1" data-bs-auto-close="outside"
                                                   data-bs-toggle="dropdown"
                                                   href="#"
                                                   role="button">
                                                    {/* <i class="ph-bold  ph-faders-horizontal f-s-20"></i> */}
                                                </a>
                                              
                                            </div>
                                        </div>
                                        <div class="offcanvas-body app-scroll">
                                            <div class="row row-cols-3">
                                                <div class="d-flex-center text-center mb-3">
                                                    <a href="/coming_soon" target="_blank">
                                                         <span class="text-light-info h-45 w-45 d-flex-center b-r-15">
                                                           <i class="ph-duotone  ph-shopping-bag-open f-s-30"></i>
                                                         </span>
                                                        <p class="mb-0 f-w-500 text-info">E-shop</p>
                                                    </a>
                                                </div>
                                                <div class="d-flex-center text-center mb-3">
                                                    <a href="mailto:support@mokshiq.in" target="_blank">
                                                        <span class="text-light-primary h-45 w-45 d-flex-center b-r-15 position-relative">
                                                          <i class="ph-duotone  ph-envelope f-s-30"></i>
                                                            <span class="position-absolute top-space-5 start-100 translate-middle p-1 bg-primary-dark rounded-circle animate__animated animate__fadeIn animate__infinite animate__fast"></span>
                                                        </span>
                                                        <p class="mb-0 f-w-500 text-primary">Email</p>
                                                    </a>
                                                </div>
                                                <div class="d-flex-center text-center mb-3">
                                                    <a href="https://wa.me/+916394856756" target="_blank">
                                                         <span class="text-light-danger h-45 w-45 d-flex-center b-r-15 position-relative">
                                                           <i class="ph-duotone  ph-chat-circle-text f-s-30"></i>
                                                             <span class="position-absolute top-space-5 start-100 translate-middle badge rounded-pill bg-success badge-notification">
                                                                    99+
                                                                    <span class="visually-hidden">unread messages</span>
                                                             </span>
                                                         </span>
                                                        <p class="mb-0 f-w-500 text-danger">Chat</p>
                                                    </a>
                                                </div>
                                                <div class="d-flex-center text-center mb-3">
                                                    <a href="tel:+916394856756" target="_blank">
                                                         <span class="text-light-warning h-45 w-45 d-flex-center b-r-15">
                                                             <i class="ph-duotone ph ph-phone f-s-30"></i>
                                                         </span>
                                                        <p class="mb-0 f-w-500 text-warning">Call Now</p>
                                                    </a>
                                                </div>
                                               


                                            </div>
                                        </div>
                                    </div>
                                </li>

                               

                                <li class="header-dark">
                                    <div class="sun-logo head-icon">
                                        <i class="iconoir-sun-light"></i>
                                    </div>
                                    <div class="moon-logo head-icon">
                                        <i class="iconoir-half-moon"></i>
                                    </div>
                                </li>

                                <li class="header-notification">
                                    <a aria-controls="notificationcanvasRight"
                                       class="d-block head-icon position-relative"
                                       data-bs-target="#notificationcanvasRight"
                                       data-bs-toggle="offcanvas"
                                       href="#"
                                       role="button">
                                        <i class="iconoir-bell"></i>
                                        <span
                                                class="position-absolute translate-middle p-1 bg-success border border-light rounded-circle animate__animated animate__fadeIn animate__infinite animate__slower"></span>
                                    </a>
                                    <div aria-labelledby="notificationcanvasRightLabel"
                                         class="offcanvas offcanvas-end header-notification-canvas"
                                         id="notificationcanvasRight" tabindex="-1">
                                        <div class="offcanvas-header">
                                            <h5 class="offcanvas-title" id="notificationcanvasRightLabel">
                                                Notification</h5>
                                            <button aria-label="Close" class="btn-close" data-bs-dismiss="offcanvas"
                                                    type="button"></button>
                                        </div>
                                        <div class="offcanvas-body notification-offcanvas-body app-scroll p-0">
                                            <div class="head-container notification-head-container">
                                                <div class="notification-message head-box">
                                                    <div class="message-images">
                                                          <span class="bg-secondary h-35 w-35 d-flex-center b-r-10 position-relative">
                                                            <img alt="avtar" class="img-fluid b-r-10"
                                                                 src="../assets/images/ai_avtar/6.jpg"/>
                                                            <span
                                                                    class="position-absolute bottom-30 end-0 p-1 bg-secondary border border-light rounded-circle notification-avtar"></span>
                                                          </span>
                                                    </div>
                                                    <div class="message-content-box flex-grow-1 ps-2">

                                                        <a class="f-s-15 text-secondary mb-0"
                                                           href="./read_email.html" target="_blank"><span
                                                                class="f-w-500 text-secondary">Gene Hart</span> wants to
                                                            edit <span
                                                                    class="f-w-500 text-secondary">Report.doc</span></a>
                                                        <div>
                                                            <a class="d-inline-block f-w-500 text-success me-1"
                                                               href="#">Approve</a>
                                                            <a class="d-inline-block f-w-500 text-danger"
                                                               href="#">Deny</a>
                                                        </div>
                                                        <span class="badge text-light-primary mt-2"> sep 23 </span>

                                                    </div>
                                                    <div class="align-self-start text-end">
                                                        <i class="iconoir-xmark close-btn"></i>
                                                    </div>
                                                </div>
                                                <div class="notification-message head-box">
                                                    <div class="message-images">
                                                        <span class="bg-light-dark h-35 w-35 d-flex-center b-r-10 position-relative">
                                                          <i class="ph-duotone  ph-truck f-s-18"></i>
                                                        </span>
                                                    </div>
                                                    <div class="message-content-box flex-grow-1 ps-2">
                                                        <a class="f-s-15 text-secondary mb-0" href="./read_email.html"
                                                           target="_blank">Hey
                                                            <span
                                                                    class="f-w-500 text-secondary">Emery McKenzie</span>,
                                                            get ready: Your order from <span
                                                                    class="f-w-500 text-secondary">@Shopper.com</span>
                                                            is out for delivery today!</a>
                                                        <span class="badge text-light-info mt-2"> sep 23 </span>

                                                    </div>
                                                    <div class="align-self-start text-end">
                                                        <i class="iconoir-xmark close-btn"></i>
                                                    </div>
                                                </div>
                                                <div class="notification-message head-box">
                                                    <div class="message-images">
                                                       <span class="bg-secondary h-35 w-35 d-flex-center b-r-10 position-relative">
                                                         <img alt="" class="img-fluid b-r-10"
                                                              src="../assets/images/ai_avtar/2.jpg"/>
                                                         <span
                                                                 class="position-absolute  end-0 p-1 bg-secondary border border-light rounded-circle notification-avtar"></span>
                                                       </span>
                                                    </div>
                                                    <div class="message-content-box flex-grow-1 ps-2">
                                                        <a class="f-s-15 text-secondary mb-0"
                                                           href="./read_email.html" target="_blank"><span
                                                                class="f-w-500 text-secondary">Simon Young</span> shared
                                                            a file called <span
                                                                    class="f-w-500 text-secondary">Dropdown.pdf</span></a>
                                                        <span class="badge text-light-success mt-2"> 30 min</span>

                                                    </div>
                                                    <div class="align-self-start text-end">
                                                        <i class="iconoir-xmark close-btn"></i>
                                                    </div>
                                                </div>
                                                <div class="notification-message head-box">
                                                    <div class="message-images">
                                                       <span class="bg-secondary h-35 w-35 d-flex-center b-r-10 position-relative">
                                                         <img alt="" class="img-fluid b-r-10"
                                                              src="../assets/images/ai_avtar/5.jpg"/>
                                                         <span
                                                                 class="position-absolute end-0 p-1 bg-secondary border border-light rounded-circle notification-avtar"></span>
                                                       </span>
                                                    </div>
                                                    <div class="message-content-box flex-grow-1 ps-2">
                                                        <a class="f-s-15 text-secondary mb-0"
                                                           href="./read_email.html" target="_blank"><span
                                                                class="f-w-500 text-secondary">Becky G. Hayes</span> has
                                                            added a comment to <span
                                                                    class="f-w-500 text-secondary">Final_Report.pdf</span></a>
                                                        <span class="badge text-light-warning mt-2"> 45 min</span>
                                                    </div>
                                                    <div class="align-self-start text-end">
                                                        <i class="iconoir-xmark close-btn"></i>
                                                    </div>
                                                </div>
                                                <div class="notification-message head-box">
                                                    <div class="message-images">
                                                        <span class="bg-secondary h-35 w-35 d-flex-center b-r-10 position-relative">
                                                          <img alt="" class="img-fluid b-r-10"
                                                               src="../assets/images/ai_avtar/1.jpg"/>
                                                          <span
                                                                  class="position-absolute  end-0 p-1 bg-secondary border border-light rounded-circle notification-avtar"></span>
                                                        </span>
                                                    </div>
                                                    <div class="message-content-box flex-grow-1 ps-2">
                                                        <a class="f-s-15 text-secondary mb-0"
                                                           href="./read_email.html" target="_blank"><span
                                                                class="f-w-600 text-secondary">Romaine Nadeau</span>
                                                            invited you to join a meeting
                                                        </a>
                                                        <div>
                                                            <a class="d-inline-block f-w-500 text-success me-1"
                                                               href="#">Join</a>
                                                            <a class="d-inline-block f-w-500 text-danger" href="#">Decline</a>
                                                        </div>

                                                        <span class="badge text-light-secondary mt-2"> 1 hour ago </span>
                                                    </div>
                                                    <div class="align-self-start text-end">
                                                        <i class="iconoir-xmark close-btn"></i>
                                                    </div>
                                                </div>

                                                <div class="hidden-massage py-4 px-3">
                                                    <img alt=""
                                                         class="w-50 h-50 mb-3 mt-2"
                                                         src="../assets/images/icons/bell.png"/>
                                                    <div>
                                                        <h6 class="mb-0">Notification Not Found</h6>
                                                        <p class="text-secondary">When you have any notifications added
                                                            here,will
                                                            appear here.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </li>

                                <li class="header-profile">
                                    <a aria-controls="profilecanvasRight" class="d-block head-icon"
                                       data-bs-target="#profilecanvasRight" data-bs-toggle="offcanvas"
                                       href="#" role="button">
                                        <img alt="avtar" class="b-r-50 h-35 w-35 bg-dark"
                                             src="../assets/images/avtar/woman.jpg"/>
                                    </a>

                                    <div aria-labelledby="profilecanvasRight"
                                         class="offcanvas offcanvas-end header-profile-canvas"
                                         id="profilecanvasRight"
                                         tabindex="-1">
                                        <div class="offcanvas-body app-scroll">
                                            <ul class="">
                                                <li class="d-flex gap-3 mb-3">
                                                    <div class="d-flex-center">
                                                    <span class="h-45 w-45 d-flex-center b-r-10 position-relative">
                                                      <img alt="" class="img-fluid b-r-10"
                                                           src="../assets/images/avtar/woman.jpg"/>
                                                    </span>
                                                    </div>
                                                    <div class="text-left mt-2">
                                                        <h6 class="mb-0"> {name} <img
                                                                alt="instagram-check-mark"
                                                                class="w-20 h-20"
                                                                src="../assets/images/profile-app/01.png"/></h6>
                                                        <p class="f-s-12 mb-0 text-secondary">{role}</p>
                                                    </div>
                                                </li>

                                                <li>
                                                    <a class="f-w-500" href="/member_setting_management" target="_blank">
                                                        <i class="iconoir-user-love pe-1 f-s-20"></i> Profile
                                                        Details
                                                    </a>
                                                </li>
                                                {/* <li>
                                                    <a class="f-w-500" href="./setting.html" target="_blank">
                                                        <i class="iconoir-settings pe-1 f-s-20"></i> Settings
                                                    </a>
                                                </li> */}
                                                <li class="app-divider-v dotted py-1"></li>
                                               
                                                <li>
                                                    <div class="d-flex align-items-center justify-content-between">
                                                        <a class="f-w-500" href="#">
                                                            <i class="iconoir-bell-notification pe-1 f-s-20"></i>
                                                            Notification
                                                        </a>
                                                        <div class="flex-shrink-0">
                                                            <div class="form-check form-switch">
                                                                <input checked
                                                                       class="form-check-input form-check-primary"
                                                                       id="basicSwitch"
                                                                       type="checkbox"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                
                                                <li class="app-divider-v dotted py-1"></li>
                                                <li>
                                                    <a class="f-w-500" href="/help" target="_blank">
                                                        <i class="iconoir-help-circle pe-1 f-s-20"></i> Help
                                                    </a>
                                                </li>
                                                
                                                <li>
                                                    <a class="mb-0 btn btn-light-danger btn-sm justify-content-center "
                                                       onClick={handleLogout}
                                                       role="button">
                                                        <i class="ph-duotone  ph-sign-out pe-1 f-s-20"></i> Log Out
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </header>
  )
}

export default Header